export default {
    i: {
        select: {
            placeholder: 'Select',
            noMatch: 'No matching data',
            loading: 'Loading'
        },
        table: {
            noDataText: 'No Data',
            noFilteredDataText: 'No filter data',
            confirmFilter: 'Confirm',
            resetFilter: 'Reset',
            clearFilter: 'All'
        },
        datepicker: {
            selectDate: 'Select date',
            selectTime: 'Select time',
            startTime: 'Start Time',
            endTime: 'End Time',
            clear: 'Clear',
            ok: 'OK',
            month: '',
            month1: 'January',
            month2: 'February',
            month3: 'March',
            month4: 'April',
            month5: 'May',
            month6: 'June',
            month7: 'July',
            month8: 'August',
            month9: 'September',
            month10: 'October',
            month11: 'November',
            month12: 'December',
            year: '',
            weeks: {
                sun: 'Sun',
                mon: 'Mon',
                tue: 'Tue',
                wed: 'Wed',
                thu: 'Thu',
                fri: 'Fri',
                sat: 'Sat'
            },
            months: {
                m1: 'Jan',
                m2: 'Feb',
                m3: 'Mar',
                m4: 'Apr',
                m5: 'May',
                m6: 'Jun',
                m7: 'Jul',
                m8: 'Aug',
                m9: 'Sep',
                m10: 'Oct',
                m11: 'Nov',
                m12: 'Dec'
            }
        },
        transfer: {
            titles: {
                source: 'Source',
                target: 'Target'
            },
            filterPlaceholder: 'Search here',
            notFoundText: 'Not Found'
        },
        modal: {
            okText: 'OK',
            cancelText: 'Cancel'
        },
        poptip: {
            okText: 'OK',
            cancelText: 'Cancel'
        },
        page: {
            prev: 'Previous Page',
            next: 'Next Page',
            total: 'Total',
            item: 'item',
            items: 'items',
            prev5: 'Previous 5 Pages',
            next5: 'Next 5 Pages',
            page: '/page',
            goto: 'Goto',
            p: ''
        },
        rate: {
            star: 'Star',
            stars: 'Stars'
        },
        tree: {
            emptyText: 'No Data'
        }
    },
    logisticsMenu: {
        logisCurrentPosition: 'Current Location',
        logisticsProvider: 'Logistics Providers',
        personalCenter: 'Personal Center',
        channelManagement: 'Channel Management',
        logisticsDealer: 'Package Management',
        customerAnalysis: 'Customer Analysis',
        customerManagement: 'Customer Management',
        waybillNumber: 'Waybill Number Management',
        pricingModelManagement: 'Billing Model',
        logisManagement: 'Logistics Base Management',
        logisBizManagement:'Logistics Business Management',
        logisAccessManagement:'Logistics access management',
        FreightForwarding:'Freight forwarding',
        OverseasWarehouse:'Overseas warehouse',
        warehouseManagement:'Warehouse Management',
        findpassword:'find password',
        dataReview:'Data audit management',
        carrierParam:'Logistics information management',
        statisticsPackageInfo:'Statistics Package Info(被动对接)',
        carrierAccount:'Logistics account management',
        accessStatistics_admin:'Logistics access management(被动对接)',
        accessStatistics:'Logistics access management',
        packageInfo:'Package Info Management(被动对接)',
        logManagement:'Log Management(主动对接)'
    },
    logisticsProvider: {
        country: 'Country',
        hasCountry: 'Selected Country',
        wayname: 'Customer',
        trackNum: 'Used Tracking Number',
        noTrackNum: 'Unused Tracking Number',
        channelName: 'Channel Name',
        channelNum: 'Channel Code',
        shippingCompanyId:'Logistics company ID',
        useAll: 'Total Usage',
        addtext: 'Text Addition',
        excelImport: 'Excel Import',
        textPlaceholder: 'Please enter the tracking number, separated by commas',
        trackExcelImport: 'Import Tracking Number',
        addTrack: 'Please select an import file',
        addFile: 'Select File',
        uploadFile: 'Upload Files',
        downLoadMoban: 'Download Template',
        baseInformation: 'Basic Information',
        remark:'The modified data provided in this interface is subject to the required data, and the non required data may not be used, which can be extended later.Please note that the default value will be filled in automatically if the part of non mandatory data is not filled in.',
        channelInformation: 'Channel Information',
        channelType: 'Types',
        packageNum: 'Number of packages',
        cost: 'Cost',
        region: 'Area',
        logisticsTrackNum: 'Logistics Tracking Number',
        packageNums: 'Package Number',
        weight: 'Weight (g)',
        date: 'Date',
        companyInfo: 'Company Information',
        exceedSize: 'File size exceeds limit, up to 10M',
        editData: 'Modify data',
        overPackage1: 'You have exceeded',
        overPackage2: 'Logistics Providers',
        addCanal: 'Add',
        addChannels: 'Add Channels',
        addWarehouse: 'Add Warehouse',
        expectTime: 'Estimated time',
        chargingModel: 'Billing Model',
        shipment: 'Logistics providers',
        shipImport: 'Import',
        addZone: 'Increase partition',
        area: 'Area',
        setChargModel: 'SetUp The Billing Model',
        province: 'Province',
        city: 'City',
        searchCity: 'Query City',
        noFile: 'Please Select Files',
        loadExcelTitle: 'Import Shipping Template',
        loadExcelShippingMethod:'Import channel template',
        downloadExcel: 'Template Download',
        selectExcel: 'Select the template you want to import',
        importSuccess: 'Import data is successful',
        priceFormula: 'Billing Formula',
        enterShipDes: 'You can enter shipping instructions',
        editWaybillNum: 'Edit Waybill Number',
        addChannelInfo: 'Add Channel Information',
        editChannelInfo: 'Edit Channel Information',
        importCountryNoFind: 'Some of the imported countries were not found in the system',
        confirmAdd: 'Confirm Add',
        selectAll: 'Select All',
        clear: 'Clear',
        addWeightArea: 'Add weight interval',
        supportSearch: 'Support Chinese, English, two-word search',
        selectedCity: 'Selected City',
        prompt: 'Prompt',
        warehouseName:'warehouse name',
        warehouseCode:'warehouse code',
        warehouse:'warehouse',
        merchant:'Merchant',
        merchantId:'Merchant ID',
        template:'Template',
        templateName:'Template Name',
        customInformation:'custom template information'
    },
    admin:{
        ttPacketId:'Package ID',
        merchantId:'Merchant ID',
        ttPacketStatus:'Package Status',
        failureReason:'Failure Reason',
        trackingNumber:'Tracking Number',
        shippingMethodCode:'Shipping Method Code',
        warehouse:'Warehouse',
        platform:'Source',
        length:'Length',
        width:'Width',
        height:'Height',
        recipientName:'Recipient’s name',
        recipientTelephone:'Recipient’s phone number',
        recipientMobile:'Recipient’s mobile phone',
        recipientEmail:'Recipient’s email',
        recipientCountry:'Recipient’s country',
        recipientState:'Recipient’s state',
        recipientCity:'Recipient’s city',
        recipientDistrict:'Recipient’s district',
        recipientCompany:'Recipient’s company',
        recipientPostalCode:'Recipient’s Postal Code',
        buyerPassportCode:'Recipient’s Identification Number',
        recipientAddress1:'Recipient’s address1',
        recipientAddress2:'Recipient’s address2',
        senderName:'Sender’s name',
        senderTelephone:'Sender’s phone number',
        senderMobile:'Sender’s mobile phone',
        senderEmail:'Sender’s email',
        senderCountry:'Sender’s country',
        senderState:'Sender’s state',
        senderCity:'Sender’s city',
        senderDistrict:'Sender’s district',
        senderCompany:'Sender’s company',
        senderPostalCode:'Sender’s Postal Code',
        senderAddress1:'Sender’s address1',
        senderAddress2:'Sender’s address2',
        declareCnName:'Declaration of Chinese product name',
        declareEnName:'Declaration of English Product Name',
        goodsSku:'Declare product SKU',
        declareNumber:'Declare the quantity of products',
        declareValue:'Declaration value of goods',
        declareWeight:'Declaration weight of goods',
        hsCode:'Customs code',
        declareUrl:'Product link for declaration',
        material:'Product material',
        purpose:'Product Usage',
        productName:'description of goods',
        sku:'SKU',
        quantity:'Quantity',
        productWeight:'Individual weight of goods',
        cargoSpace:'Location number',
        iossMethod:'Prepaid value-added tax method',
        iossNo:'Seller IOSS tax number',
        eoriNo:'Seller EORI tax number',
        voecNo:'Seller’s VOEC tax number',
        gstNo:'Seller’s GST tax number',
        vatNo:'Seller’s VAT number',
        salesRecordNumber:'Sales order number',
        carrierOrderId:'Carrier Order ID',
        virtualTrackingNumber:'Virtual Tracking Number',
        uploadCarrier:'Upload Carrier',
        weight:'Weight',
        freight:'Freight',
        templateType:'Label Type',
        templateContent:'Label Url',
        createdDate:'Package generation time',
        lastsyncTime:'Latest synchronization time',
        requestId:'Request ID',
        source:'Source',
        apiInterface:'Logistics provider identification',
        method:'HTTP method',
        interfaceFlag:'Interface identification',
        carrierId:'Carrier ID',
        rangeTime:'Time frame',
        packageStatus:'Package Status',
        packageNum:'Package Number'
    },
    sellerMenu: {
        sellerCurrentPosition: 'Current Location',
        seller: 'Seller',
        personalCenter: 'Personal Center',
        logisticsPlan: 'Logistics Plan Inquiry',
        logisticsTracking: 'Logistics Tracking',
        logisticsReconciliation: 'Logistics Reconciliation',
        logisBillManage: 'Logistics Bill Management',
        logisticsProvider: 'Logistics Provider Analysis',
        logisticsChannel: 'Logistics Channel Analysis',
        logisticsDetails: 'Logistics Details',
        overseasWarehouse: 'Overseas Warehouse',
        overseasWarehouseDtl: 'Overseas Warehouse Details',
        overseasWarehouseInvent: 'Overseas Warehouse Inventory',
        overseasWarehouseBill: 'Overseas Warehouse Bill'
    },
    sellers: {
        overSeller1: 'You have exceeded',
        overSeller2: 'Seller',
        countrys: 'Destination Country',
        packageWeights: 'Package Weight',
        packageVolumes: 'Package Volume',
        packageType: 'Package Type',
        productsType: 'Goods Type',
        isEnabled: 'Whether To Enable',
        receiveCity: 'Collecting Cities',
        selectCity: 'Select Collect Cities',
        userContactInfoTitle: 'Your Contact Information',
        shippingMethodName: 'Channel Name',
        carrierName: 'Logistics Providers Name',
        tongtoolExpoent: 'Tongtool Recommended',
        averageTime: 'Average Aging',
        avgNetTime: 'Average Internet Time',
        availableTrackingRate: 'Effective Tracking Rate(%)',
        lostPackageRate: 'Lost Package Rate',
        pickupRate: 'PickUp Rate',
        selectCarrier: 'Select Logistics Providers',
        packageNums: 'Package Number',
        trackingNumber: 'Shipment Number',
        erpPackageWeight: 'Tongtool Weight',
        packageWeight: 'Logistician Weight',
        weightAddRatio: 'Weight Add Ratio(%)',
        erpPackageCost: 'Tongtool Cost',
        packageCost: 'Logistics Provider Cost',
        costs: 'Cost',
        costAddRatio: 'Cost Add Ratio(%)',
        selectExcel: 'Select the template you want to import',
        confirmImport: 'Confirm Import',
        importLogisWeights: 'Import Logistics Provider Weight And Cost',
        packageQuantity: 'Number Of Packages',
        useRatio: 'Use Ratio(%)',
        costRatio: 'Cost Ratio(%)',
        shippingMethodCode: 'Channel Code',
        isValid: 'Status',
        shipDetails: 'Details',
        avgDelieveredTime: 'Average Delievered Time',
        shortDelieveredTime: 'Short Delievered Time',
        longDelieveredTime: 'Long Delievered Time',
        platform: 'Platform',
        storeName: 'Shop',
        country: 'Country',
        shippingMethods: 'Shipping Method',
        recentData: 'Statistics of the last 90 days of data',
        logisTrackInfo: 'Logistics Tracking Information',
        targetLanguage: 'Please Select Convert Language',
        copyResult: 'Copy Result',
        copyLink: 'Copy Link',
        languageConver: 'Language Conversion',
        packetStatus: 'Package Status',
        transportMethods: 'Transport Method',
        transportTime: 'Transport Time',
        basicInfo: 'Basic Information',
        timeAndFreight: 'Time And Freight',
        templateManagement: 'Sheet Management',
        tongToolTemplate: 'Tongtool Template',
        logisTemplate: 'Logistics Template',
        personalTemplate: 'Personal Template',
        arrivalTime: 'Expected Time',
        unableShow: '该字段暂时无法显示',
        contactLogisProvider: 'Contact Logistics Provider',
        channelDtlTitle: 'Channel Details',
        estimateFreight: 'Estimated Shipping Cost',
        querying: 'Querying',
        delivering: 'Delivering',
        pickingUp: 'Picking Up',
        signingSuccess: 'Success Signing',
        unableCheck: 'Unable Check',
        deliveryFail: 'Delivery Failure',
        transportLong: 'Transport Long',
        maybeAbnormal: 'Maybe Abnormal',
        logisFreightModel: 'Logistics Billing Model',
        customShipModel: 'Custom Billing Model',
        billGenerateTime: 'Bill Generation Time',
        importBill: 'Import Bill',
        billTimes: 'Billing Time',
        selectBillTime: 'Please select Bill Generation Time',
        downloadDetails: 'Download Details',
        downloads: 'download',
        paymentStatus: 'Payment Status',
        markAsPaid: 'Mark As Paid',
        selectLogisProvider: 'Please select a logistics provider',
        selectBillingTime: 'Please select billing time',
        paid: 'Paid',
        unPaid: 'Unpaid',
        importFormFile: 'Import Form File'
    },
    common: { // 重复类名词 + 公共操作提示
        merchantId: 'Merchant Number',
        partnerId: 'User Number',
        companyName: 'Company Name',
        displayCarrierName:'Name of logistics provider displayed in transit',
        companyAds: 'Company Address',
        email: 'Business Mailbox',
        mobile: 'Mobile Number',
        contactName: 'Contact',
        businessLicense:'Business License',
        selectFile:'Select File',
        supportPdf:'Support uploading pdf',
        telephone: 'Contact Number',
        packNum: 'Package Number(the number of packages in the past 30 days)',
        yesterdayPm: 'Yesterday Package Number',
        packageAmount: 'Package Amount',
        dates: 'Date',
        nocompanyImg: 'No Picture Yet',
        dataSources: 'Data Source: Tongtool Logistics Platform',
        productServer: 'Product Service',
        productName: 'Product Name',
        productDes: 'Product Introduction',
        orderPrice: 'Order Price',
        productStatus: 'Status',
        searchName: 'Search Character',
        markSuccess: 'Marked Success',
        markFailed: 'Marked Failure',
        editSuccess: 'Modified Success',
        saveSuccess: 'Saved Success',
        editFailed: 'Modified Failure',
        saveFailed: 'Saved Failure',
        delSuccess: 'Deleted Success',
        delFailed: 'Delete failed, please try again',
        clearMakrSuccess: 'Label Emptying Success',
        operateSuccess: 'Operating Success',
        operateFailMes: 'Operating Failure, Please Try Again',
        sysErrorMes: 'System Busy, Please Try Again',
        lastWeek: 'Last Week',
        lastMonth: 'Last Month',
        last3months: 'Last Three Months',
        selectDate: 'Select Date',
        deliveryDate: 'Ship Date',
        search: 'Search',
        statisticsAllPackageInfo:'Collect all package information',
        reset: 'Reset',
        status: 'Status',
        checkStatus: 'Audit status',
        checkStatusFinish: 'Audit completed',
        operation: 'Operate',
        sort: 'Sort',
        close: 'Close',
        save: 'Save',
        submit: 'Submit',
        saveAndApproval:'Save and submit for approval',
        cancel: 'Cancel',
        edit: 'Edit',
        cancelEdit: 'Cancel Edit',
        all: 'All',
        examine: 'Check',
        del: 'Delete',
        logout: 'log out',
        inputPrefix: 'Please Enter',
        selectPrefix: 'Please Select',
        enableOk: 'Enabled Success',
        disableOk: 'Disabled Success',
        delOk: 'Delete Success',
        addOk: 'Add Success',
        updateOk: 'Update Success',
        deleteConfirm: 'Whether to confirm the deletion?',
        confirm: 'Confirm',
        notNull: 'Can Not Be Empty',
        processing: 'Processing...',
        emptyResult: 'No Related Records',
        warningMesTitle: 'Warning',
        selectFile: 'Select File',
        startUpload: 'Start Upload',
        shipImport: 'Import',
        shipExport: 'Export',
        exportSuccess: 'Export Success',
        tableNoData: 'There is currently no data to export',
        selectCountry: 'Select Country',
        selectShipMethods: 'Select Shipping Methods',
        priceType: 'Billing Method',
        priceType0: 'Normal Billing',
        priceType1: 'First continuous re-billing',
        priceType2: 'Separate Billing',
        weightType: 'Weighting method',
        weightType0: 'Net Weight',
        weightType1: 'Throw Weight',
        weightType2: 'Comparison between the two',
        subCostWay0: 'Unit Weight',
        subCostWay1: 'Fixed Charge',
        subCostWay2: 'First Charge',
        tableDes0: 'Freight = (Weight * Unit Price + Registration Fee + Operation Fee) * (One + Additional Fee)',
        tableDes1: 'Freight = {First Weight Fee + (Package Weight - First Weight) / Continued Weight Unit Weight * Continued Weight Unit Price + Registration Fee + Operation Fee} * (One + Additional Fee)',
        tableDes2: 'Freight = (Unit Price + Registration Fee + Operation Fee) * (One + Additional Fee)',
        logisType1: 'Surface Mail',
        logisType2: 'Registered',
        logisType3: 'Dedicated Line',
        logisType4: 'Commercial Express',
        logisType5: 'FBA Head',
        serialNum: 'Index',
        status0: 'Disable',
        status1: 'Enable',
        companyAttr:'Company properties',
        thirdLogis:'Third party logistics',
        overseasWarehouse:'Overseas warehouse',
        checkBtn:'to examine',
        refuseBtn:'refuse',
        rejected:'Rejected',
        dataReviewStatus:'Audit status',
        dataReviewStatus0:'Pending application',
        dataReviewStatus1:'To be reviewed',
        dataReviewStatus2:'Audit succeeded',
        dataReviewStatus3:'Audit failed',
        searchText:'Company name / mobile phone number / email address / Carrier Name',
        checkstatus0: 'Pending',
        checkstatus1: 'Audited',
        checkstatus2: 'Rejected',
        checkstatus:'Audit pass',
        checkstatusRj:'Review Rejected',
        cargo: 'Cargo',
        battery: 'Battery',
        supBattery: 'Matching Battery',
        liquid: 'Liquid',
        medicine: 'Medicine',
        powder: 'Powder',
        dangerous: 'Dangerous',
        package: 'Package',
        file: 'File',
        yes: 'Yes',
        not: 'No',
        referTime: 'Refer Time',
        safeServe: 'Safe Service',
        sizeLimit: 'Size Limit',
        useWeight: 'Use Weight',
        packageType: 'Accept Package Type',
        acceptType: 'Accept Type',
        haveTrackNum: 'Whether Tracking Number',
        channelTypes: 'Channel Type',
        isPrintTemplate: 'Whether to support API interface to transfer tags',
        updateToErp:'Push to erp2.0',
        confirmRequired: 'Whether To Deliver',
        volumeWeight: 'Volume Weight',
        trackUrl: 'Tracking Information Query URL',
        collectCity: 'Collecting Cities',
        dyParams: 'Dynamic Parameter',
        dyParamsExtend: 'Dynamic Parameter Extend Info',
        sendExplain: 'Shipping Instructions',
        searchLogisName: 'Search Logistics Name',
        searchChannelName: 'Search Channel Name',
        searchChannelCode:'Search Channel Code',
        warehosueName:'Warehosue Name',
        submitSuccess: 'Submitted successfully, waiting for the logistics provider to contact you',
        pleaseEnter: 'Please check if the value you filled in meets the requirements',
        importFileSuccess: 'Import File Success',
        importFileFail: 'Import File failed',
        fileFormats: 'File Format',
        subArea: 'Part Area',
        reachState: 'Reach Country',
        costPrice: 'Price (yuan/g)',
        fixPrice: 'Price（yuan/ticket）',
        registrationFee: 'Registration Fee (yuan/ticket)',
        operatingCost: 'Operating Fee (yuan/ticket)',
        additionalFeeRate: 'Additional Fee(%)',
        firstWeight: 'First Weight (g)',
        firstWeightPrice: 'First Weight Freight (yuan)',
        unitWeight: 'Continued Weight Unit Weight (g)',
        unitWeightPrice: 'Continued Weight Unit Price (yuan)',
        monetaryUnit: 'Yuan',
        unitWeightTwo: 'Continued Weight',
        firstWeightTwo: 'First Weight',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        pleaseSelect: 'Please Select',
        fileSizeLimit: 'Exceeding file size limit',
        moreSize: 'Too big, can not exceed 2M',
        findSameCountry: 'When the template import finds the same country',
        cover: 'Cover',
        ignore: 'Ignore',
        errorMessage: 'Error Message',
        downloadErrorLog: 'Download Error Log',
        startWeights: 'Start Weight (g)',
        endWeights: 'End Weight <=(g)',
        batchImport: 'Batch Import',
        newPartition: 'New partition',
        backToList: 'Back to list',
        checkErrorLog: 'The billing model is imported incorrectly. Please check the error log',
        isCheckStatus:'Is audit required',
        label:"Self made template",
        userNo:'User number',
        carrierCode:'Logistics provider code',
        apiType:'Api Type code',
        carrierType:'carrier type',
        remark:'remark',
        appmanage:'Application management',
        addparam:'New parameter',
        parameterName:'Parameter name',
        parameterKey:'Parameter key',
        parameterType:'Parameter Type',
        businessType:'Parameter business type',
        dataType:'Data Type',
        optionName:'Option name',
        optionValue:'Option value',
        addAccount:'Add account',
        updateAccount:'Update account',
        updatePassword:'Update password',
        hasAccount:'Is there an account',
        alreadyAccount:'Existing account',
        noAccount:'No account',
        accountName:'Number name',
        password:'Password',
        account:'Account',
        carrierSystem:'Carrier System',
        sync:'synchronization',
        initExtend:'Init ShippingMethod Extend Info',
        bindType:'Bind Type',
        isSupportSmartRouting:'Does it support intelligent routing',
        isSupportPrivateChannelSync:'Does it support synchronizing customers’ private channels',
        isSupportSecondaryForecast:'Does it support secondary forecasting services',
        secondaryForecastType:'Secondary forecast type',
        isEnableSynStock:'Does it support API synchronization of inventory',
        isSupportApiRecord:'Does it support API supplementary recording of shipping fees',
        accessTime:'Accessed',
        packageCreatedTime:'Package creation time',
        accessTimeRange:'Access time range',
        totalTimes:'Access frequency',
        callMethod:'Interface Name',
    },
    validValue: { // 所有的校验callback内容都写在这里，避免重复
        noEmpty: 'The content can not be blank',
        errorDate: 'Incorrect date format',
        fileError: 'Incorrect file format',
        inputError: 'Incorrect input format',
        floatNeed: 'This option only allows you to enter an integer or two decimal places',
        noshipMethodName: 'Channel name cannot be empty',
        noMerchantId: 'Merchant cannot be empty',
        noTemplateId: 'Template cannot be empty',
        nowarehosueName: 'Warehouse name cannot be empty',
        noshipMethodCode: 'Channel code cannot be empty',
        nowarehouseCode: 'Warehouse code cannot be empty',
        noReceiveType: 'Please select a receive type',
        noLogisType: 'Please select a channel type',
        noEfficiencyMin: 'Minimum reference aging cannot be empty',
        noEfficiencyMax: 'Maximum reference aging cannot be empty',
        noLength: 'Length cannot be empty',
        noWidth: 'Width cannot be empty',
        noHeight: 'Height cannot be empty',
        noWeightStart: 'Weight start value cannot be empty',
        noWeightEnd: 'Weight cutoff cannot be empty',
        chMethodCode: 'Channel code cannot be Chinese',
        isInteger: 'Can only enter Integer',
        noLessZero: 'Cannot be less than zero',
        minTimeNoLessZero: 'Minimum reference aging cannot be less than zero',
        noLessOrEqualZero: 'Cannot be less than or equal zero',
        maxTimeNoLessOrEqualZero: 'Maximum reference aging cannot be less than or equal zero',
        lengthNoLessOrEqualZero: 'Length cannot be less than or equal zero',
        widthNoLessOrEqualZero: 'Width cannot be less than or equal zero',
        heightNoLessOrEqualZero: 'Height cannot be less than or equal zero',
        startWeightNoLessZero: 'Applicable weight start value cannot be less than zero',
        endWeightNoLessOrEqualZero: 'Applicable weight cutoff value cannot be less than or equal zero',
        trackUrlError: 'Incorrect track url format',
        noCountrys: 'Please select a country',
        noCitys: 'Please select collect the citys',
        noPackageWeight: 'Package weight cannot be empty',
        noCompanyName: 'Company name cannot be empty',
        noCompanyAddress: 'Company address cannot be empty',
        noEmail: 'E-mail can not be empty',
        emailError: 'Incorrect email format',
        noLinkMan: 'Contact cannot be empty',
        noCellphone: 'Phone number can not be blank',
        phoneError: 'Incorrect mobilePhoneNumber format',
        noStartMoreEnd: 'The weight start value cannot be greater than or equal to the weight cutoff value',
        noStartTimeMoreEndTime: 'The aging start value cannot be greater than or equal to the aging cutoff value',
        trackingNumberError: 'The tracking number entered is not a number or a letter',
        noEnterTrackingNumber: 'No tracking number is currently entered',
        trackingNotRepeat: 'Tracking number cannot be repeated',
        noHasTrackingNumber:'Is there a tracking number that cannot be empty',
        nobusinessLicense:'Business receipt must be uploaded',
        nocarrierCode:'Logistics provider code is required',
        noremark:'Remarks must',
        noAccount:'Account number cannot be empty',
        noPassword:'Password cannot be empty',
        noBindType:'Binding type cannot be empty'
    },
    error: {
        importError: 'Import failed, please fill in the required fields',
        repeatImportCountry: 'Repeated import into the country',
        importSameCountry: 'Cannot add the same country repeatedly, please re-select import',
        addWeightInterval: 'Please add a weight interval',
        startWeightNoEmpty: 'Start weight cannot be empty',
        endWeightNoEmpty: 'End weight cannot be empty',
        endWeightNoZero: 'End weight cannot be zero',
        endNoLessOrEqualStart: 'End weight cannot be less than or equal to the start weight',
        startWeightOnlyInteger: 'The start weight can only be a positive integer',
        endWeightOnlyInteger: 'The end weight can only be a positive integer',
        pricesOnlyFiveDecimals: 'The prices can only hold up to five decimals',
        firstWeightPriceOnlyFiveDecimals: 'The first weight price can only hold up to five decimals',
        unitWeightPriceOnlyFiveDecimals: 'The continuous unit price can only hold up to five decimals',
        registrationFeeOnlyFiveDecimals: 'The registration fee can only hold up to five decimals',
        operatingFeeOnlyFiveDecimals: 'The operating fee can only hold up to five decimals',
        additionalFeeOnlyFiveDecimals: 'The additional fee can only hold up to five decimals',
        endMoreStartWeight: 'The cutoff weight of the previous partition cannot be greater than or equal to the starting weight of the next partition',
        countryAlreadyExist: 'The current state already exists in the current billing model and cannot be re-selected',
        importTableError: 'Import failed, please check if the imported table content meets the requirements',
        shippingError: 'Channel name or code already exists',
        saveError: 'The save failed, please check if the value you filled in meets the requirements',
        fileFormatError: 'Incorrect file format',
        noImportFiles: 'Please select the file you want to import',
        delPricingColumnsError: 'Keep at least one weight interval',
        nonCountry: 'Please select a country of access and cannot be repeated',
        selectModalFile: 'Please select the template you want to import',
        disableInsert: 'Have unfilled partitions',
        decimalError: 'Cannot be empty and can only hold up to five decimal places',
        priceError: 'The price cannot be empty and cannot be zero',
        firstWeightError: 'The first weight cannot be empty and cannot be zero',
        firstWeightPriceError: 'The first weight price cannot be empty and cannot be zero',
        unitWeightError: 'Continued weight cannot be empty and cannot be zero',
        unitWeightPriceError: 'The continuous weight price cannot be empty and cannot be zero',
        weightRegionError: 'A positive integer whose weight interval cannot be empty',
        delCachePricingData: 'Keep at least one piece of data',
        templateDataError: 'Upload failed, template data in excel cannot be empty',
        templateDataError14: 'Table parameters of common billing templates are mismatched or incomplete',
        templateDataError15: 'Access to a country can not be empty',
        templateDataError16: 'Freight can not be empty',
        templateDataError17: 'Incorrect Freight format',
        templateDataError18: 'Incorrect Registration Fee format',
        templateDataError19: 'Incorrect Operation Fee format',
        templateDataError20: 'Incorrect Additional Fee format',
        templateDataError21: 'The first continuation of the billing form parameter is mismatched or incomplete',
        templateDataError22: 'First Weight can not be empty',
        templateDataError23: 'Incorrect First Weight format',
        templateDataError24: 'The first Weight freight can not be empty',
        templateDataError25: 'Incorrect first Weight freight format',
        templateDataError26: 'Unit weight can not be empty',
        templateDataError27: 'Incorrect Unit weight format',
        templateDataError28: 'The unit price of renewal weight can not be empty',
        templateDataError29: 'Incorrect unit price of renewal weight format',
        templateDataError30: 'Freight price must be greater than zero',
        templateDataError31: 'Accessible countries are not found in the system',
        templateDataError32: 'The first weight must be greater than zero',
        templateDataError33: 'The first heavy freight must be greater than zero',
        templateDataError34: 'The Continued Weight must be greater than zero',
        templateDataError35: 'The Continuous freight must be greater than zero',
        templateDataError36: 'Interval weight or freight must be greater than zero',
        templateDataError37: 'Incorrect Interval weight or freight format',
        templateDataError38: 'Segmented billing form parameters are mismatched or incomplete',
        templateDataError41: 'Logistics reconciliation file content does not match',
        templateDataError42: 'Logistician weight format error',
        templateDataError43: 'Logistics provider fee format error',
        currentNoData: 'There is currently no table data to manipulate',
        importWayBillNumExists: 'The imported waybill number already exists',
        shipDateNoEmpty: 'Shipping Date cannot be empty',
        curTableNotData: 'The current table data is empty and cannot be imported into excel data',
        errorTip10029: 'National information cannot be empty',
        errorTip20044: 'Package weight cannot be empty',
        errorTip20045: 'Package volume cannot be empty',
        errorTip10006: 'Remove fail',
        errorTip90002: 'System busy, please try again later',
        errorTip90003: 'Internal system exception, please contact the administrator',
        errorTip90004: 'Database error',
        errorTip10010: 'Parameter error',
        errorTip10011: 'The parameter is empty',
        errorTip10012: 'Parameter object is empty',
        errorTip10014: 'CLIENT ID is illegal',
        errorTip10015: 'SECRET is not legal',
        errorTip10016: 'Object already exists',
        errorTip10017: 'RESTFUL call failed',
        errorTip10018: 'Object is empty',
        errorTip10019: 'Access ES error',
        errorTip10020: 'Query tracking information is abnormal',
        errorTip10021: 'Logistics provider does not exist',
        errorTip10022: 'Excel file format error',
        errorTip10023: 'No found Logistics providers',
        errorTip10024: 'No found system country information',
        errorTip10025: 'Excel file export exception',
        errorTip10026: 'No result information was found',
        errorTip10027: 'Merchant ID can not be empty',
        errorTip10028: 'Shipping method ID can not be empty',
        errorTip20050: 'Tracking number parameter file is empty',
        errorTip20051: 'Modify channel status parameter to empty',
        errorTip20052: 'Modify channel id parameter to empty',
        errorTip20053: 'The billing mode parameter is empty',
        errorTip20054: 'Billing model file parameter is empty',
        errorTip20055: 'The EXCEL file format is incorrect. Please fill in the value in the surcharge column. If there is no, fill in the zero',
        errorTip20056: 'File parameter is empty',
        errorTip20057: 'Save the statistics report parameter list is empty',
        errorTip20073: 'Has trackingNumber is empty',
        errorTip20074: 'Warehouse code cannot be empty',
        errorTip20075: 'Warehouse name cannot be empty',
        errorTip20076: 'Warehouse name or code already exists',
        errorTip20077: 'Warehouse ID cannot be empty',
        errorTip20078: 'Warehouse status cannot be empty',
        errorTip20079: 'Api interface cannot be empty',
        selectWarehouse:'Please select a warehouse first'
    }
};


// WEBPACK FOOTER //
// ./src/components/locale/lang/en-US.js